const LogTypes = ['log', 'info', 'warn', 'error'] as const;

export type LogType = (typeof LogTypes)[number];

export type LogFnType = (scope: string, type: LogType, ...args: any[]) => void;

let logModule = '未知';

let _log: LogFnType

export default {
  init (log: LogFnType) {
    _log = log;
  },
  scope(module: string) {
    logModule = module || '未知';
    return LogTypes.reduce((previousValue, type) => ({
      ...previousValue,
      [type]: (...args: any[]) => {
        if (!_log) {
          console.warn('请先调用logger.init');
          return
        }

        _log(logModule, type, ...args)
      }
    }), {} as Record<LogType, (...args: any[]) => void>);
  },
};
